/* Shopify is the source of truth for stock, prices, discounts and cart totals. */
(() => {
  let cartMutationBusy = false;
  document.documentElement.classList.add('mr-cart-auto-add');
  document.addEventListener('change', event => {
    const selector = event.target.closest('form[data-mr-auto-add] select[data-mr-auto-select]');
    if (!selector || !selector.value || cartMutationBusy || document.documentElement.hasAttribute('data-maroni-gift-busy')) return;
    selector.form.requestSubmit();
  });
  function preserveSize(nav) {
    const options = JSON.parse(nav.querySelector('[data-mr-source]').textContent);
    const size = options.find(o => /^(size|sizes)$/i.test(o.name));
    if (!size) return;
    const productInfo = nav.closest('product-info');
    const picker = productInfo?.querySelector('variant-selects');
    const field = [...(picker?.querySelectorAll('fieldset, .product-form__input--dropdown') || [])]
      .find(el => /size/i.test(el.querySelector('legend,label')?.textContent || ''));
    const selected = field?.querySelector('input:checked, option:checked')?.value || size.selected_value;
    if (!selected) return;
    nav.querySelectorAll('a[data-mr-variants]').forEach(link => {
      const index = JSON.parse(link.dataset.mrOptions).findIndex(name => /^(size|sizes)$/i.test(name));
      const match = JSON.parse(link.dataset.mrVariants).find(v => v.available && v.options[index] === selected);
      const url = new URL(link.href);
      if (match) url.searchParams.set('variant', match.id); else url.searchParams.delete('variant');
      link.href = url.toString();
    });
  }
  document.addEventListener('click', e => {
    const nav = e.target.closest('[data-mr-siblings]');
    if (nav) preserveSize(nav);
  });
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-mr-add], form[data-mr-gift-review]');
    if (!form) {
      if (e.submitter?.name === 'checkout' && document.querySelector('[data-mr-unresolved]')) {
        e.preventDefault();
        document.querySelector('[data-mr-unresolved]')?.scrollIntoView({block:'center'});
        document.querySelector('[data-mr-unresolved] button')?.focus();
      }
      return;
    }
    e.preventDefault();
    const panel = form.closest('maroni-cart-offers');
    if (cartMutationBusy || panel.dataset.busy || document.documentElement.hasAttribute('data-maroni-gift-busy')) return;
    const error = panel.querySelector('[role="alert"]');
    const drawer = document.querySelector('cart-drawer');
    const body = new FormData(form);
    if (e.submitter?.name) body.set(e.submitter.name,e.submitter.value);
    const notice = panel.querySelector('[data-mr-cart-notice]');
    const controls = [...document.querySelectorAll('maroni-cart-offers button, maroni-cart-offers select')].filter(control => !control.disabled);
    const addedMessage = form.dataset.addedMessage || '';
    cartMutationBusy = true;
    panel.dataset.busy = 'true';
    form.setAttribute('aria-busy', 'true');
    controls.forEach(control => { control.disabled = true; });
    error.hidden = true;
    if (notice) notice.textContent = panel.dataset.addingMessage;
    if (drawer) {
      body.set('sections','cart-drawer,cart-icon-bubble');
      body.set('sections_url',location.pathname);
    }
    try {
      const response = await fetch(form.action + '.js', {method:'POST',body,headers:{'Accept':'application/json'}});
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to update your bag. Please try again.');
      if (panel.dataset.surface === 'page' || !drawer || !data.sections?.['cart-drawer']) {
        location.assign(window.routes.cart_url); return;
      }
      drawer.renderContents(data);
      if (typeof publish === 'function') await publish(PUB_SUB_EVENTS.cartUpdate,{source:'maroni-upsell',cartData:data});
      const confirmation = drawer.querySelector('.mr-drawer-incentives [data-mr-cart-notice]');
      if (confirmation) confirmation.textContent = addedMessage;
      requestAnimationFrame(() => drawer.querySelector('.drawer__close')?.focus());
    } catch (err) {
      error.textContent = err.message || panel.dataset.errorMessage;
      error.hidden = false;
      const selector = form.querySelector('[data-mr-auto-select]');
      if (selector) selector.value = '';
      if (notice) notice.textContent = '';
      requestAnimationFrame(() => form.querySelector('select, button')?.focus());
    } finally {
      cartMutationBusy = false;
      delete panel.dataset.busy;
      form.removeAttribute('aria-busy');
      controls.forEach(control => { if (control.isConnected) control.disabled = false; });
    }
  });
})();
/* Reconcile checkout after Dawn replaces cart sections following a quantity edit. */
(() => {
  let queued = false;
  function reconcile() {
    queued = false;
    const review = !!document.querySelector('[data-mr-unresolved]');
    document.querySelectorAll('button[name="checkout"]').forEach(button => {
      if (review) { button.dataset.maroniReview = 'true'; button.disabled = true; }
      else if (button.dataset.maroniReview) {
        delete button.dataset.maroniReview;
        button.disabled = !!button.closest('.is-empty');
      }
    });
    document.querySelectorAll('.additional-checkout-buttons').forEach(el => {el.hidden = review;});
  }
  new MutationObserver(() => {
    if (!queued) {queued = true; queueMicrotask(reconcile);}
  }).observe(document.body,{childList:true,subtree:true});
  reconcile();
})();
(() => {
  const positions = new Map();
  let setBusy = false;
  if (!customElements.get('maroni-progress')) customElements.define('maroni-progress', class extends HTMLElement {
    connectedCallback() {
      const key = this.dataset.surface;
      const target = Number(this.dataset.progress);
      const fill = this.querySelector('.mr-progress-fill');
      const previous = positions.get(key);
      positions.set(key, target);
      if (!fill || previous === undefined || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      fill.style.transition = 'none';
      fill.style.width = previous + '%';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (!this.isConnected) return;
        fill.style.transition = '';
        fill.style.width = target + '%';
      }));
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-mr-set]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.enabled !== 'true' || form.dataset.busy || setBusy || document.documentElement.hasAttribute('data-maroni-gift-busy')) return;
    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[role="alert"]');
    const drawer = document.querySelector('cart-drawer');
    const body = new FormData(form);
    body.set('sections', 'cart-drawer,cart-icon-bubble');
    body.set('sections_url', location.pathname);
    setBusy = true;
    form.dataset.busy = 'true'; button.disabled = true; button.setAttribute('aria-busy', 'true'); error.hidden = true;
    try {
      const cartResponse = await fetch(window.routes.cart_url + '.js', {headers:{Accept:'application/json'}});
      if (!cartResponse.ok) throw new Error(form.dataset.error);
      const currentCart = await cartResponse.json();
      if (currentCart.currency !== 'AUD') throw new Error(form.dataset.currencyError);
      const state = window.MaroniSetCart.inspect(currentCart, JSON.parse(form.dataset.swimProductIds), JSON.parse(form.dataset.capProductIds));
      const pairs = Number(form.dataset.pairs);
      if (state.giftPresent && pairs > 2) {
        for (const key of [...body.keys()]) if (key.startsWith('items[' + pairs + ']')) body.delete(key);
      }
      const response = await fetch(form.action + '.js', {method:'POST',body,headers:{Accept:'application/json'}});
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message);
      if (!drawer || !data.sections?.['cart-drawer']) { location.assign(window.routes.cart_url); return; }
      drawer.renderContents(data);
      requestAnimationFrame(() => drawer.querySelector('.drawer__close')?.focus());
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source:'maroni-set',cartData:data});
    } catch (err) {
      error.textContent = err.message || form.dataset.error;
      error.hidden = false;
    } finally {
      setBusy = false; delete form.dataset.busy; button.disabled = false; button.removeAttribute('aria-busy');
    }
  });
})();

document.addEventListener('change', event => {
  const choice = event.target.closest('[data-mr-cap-preview] input[type="radio"]');
  if (!choice) return;
  if (!choice.closest('maroni-preview-cap')) choice.closest('[data-mr-cap-preview]').querySelector('[role="status"]').textContent = choice.dataset.message;
});

if (!customElements.get('maroni-preview-cap')) customElements.define('maroni-preview-cap', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.addEventListener('change', event => {
      const choice = event.target.closest('input[type="radio"]');
      if (!choice) return;
      try {
        sessionStorage.setItem('maroni-draft-cap', choice.value);
        sessionStorage.setItem('maroni-draft-cap-colour', choice.value);
        sessionStorage.setItem('maroni-draft-cap-mode', this.dataset.gift === 'true' ? 'gift' : 'paid');
        sessionStorage.removeItem('maroni-draft-cap-declined');
      } catch {}
      this.showChoice(choice, true);
      document.dispatchEvent(new Event('maroni:preview-cap'));
    });
    this.querySelector('[data-mr-remove-preview-cap]').addEventListener('click', () => {
      try {
        sessionStorage.removeItem('maroni-draft-cap');
        sessionStorage.setItem('maroni-draft-cap-declined', 'yes');
      } catch {}
      this.querySelectorAll('input[type="radio"]').forEach(input => {input.checked = false;});
      this.querySelector('[data-mr-preview-cap-line]').hidden = true;
      this.querySelector('[role="status"]').textContent = this.dataset.removedMessage;
      document.dispatchEvent(new Event('maroni:preview-cap'));
    });
    this.sync = () => this.restoreChoice();
    document.addEventListener('maroni:preview-cap', this.sync);
    this.restoreChoice();
  }
  disconnectedCallback() { document.removeEventListener('maroni:preview-cap', this.sync); }
  restoreChoice() {
    let colour, mode, declined, preference;
    try {
      colour = sessionStorage.getItem('maroni-draft-cap');
      mode = sessionStorage.getItem('maroni-draft-cap-mode');
      declined = sessionStorage.getItem('maroni-draft-cap-declined');
      preference = sessionStorage.getItem('maroni-draft-cap-colour');
      if (this.dataset.gift !== 'true') {
        sessionStorage.removeItem('maroni-draft-cap-declined');
        if (mode === 'gift') { colour = null; sessionStorage.removeItem('maroni-draft-cap'); sessionStorage.removeItem('maroni-draft-cap-mode'); }
      }
    } catch {}
    if (this.dataset.gift === 'true' && declined !== 'yes') {
      colour ||= preference || this.querySelector('input[type="radio"]')?.value;
      try { sessionStorage.setItem('maroni-draft-cap', colour); sessionStorage.setItem('maroni-draft-cap-mode', 'gift'); } catch {}
    }
    const selected = [...this.querySelectorAll('input[type="radio"]')].find(input => input.value === colour);
    if (selected) this.showChoice(selected, false);
    else {
      this.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = false; });
      this.querySelector('[data-mr-preview-cap-line]').hidden = true;
    }
  }
  showChoice(choice, announce) {
    choice.checked = true;
    const image = choice.closest('label').querySelector('img');
    const lineImage = this.querySelector('[data-mr-preview-cap-image]');
    if (image) {lineImage.src = image.currentSrc || image.src; lineImage.alt = image.alt;}
    this.querySelector('[data-mr-preview-cap-title]').textContent = choice.getAttribute('aria-label');
    this.querySelector('[data-mr-preview-cap-line]').hidden = false;
    if (announce) this.querySelector('[role="status"]').textContent = choice.dataset.addedMessage;
  }
});

/* Recover Shopify's partially successful stock-limited adds from server HTML. */
(() => {
  let message;
  try { message = sessionStorage.getItem('maroni-stock-refresh'); sessionStorage.removeItem('maroni-stock-refresh'); } catch {}
  if (!message) return;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  const notice = drawer.querySelector('.mr-drawer-incentives .mr-cart-error') || document.createElement('p');
  notice.className = 'mr-cart-error'; notice.setAttribute('role', 'alert'); notice.textContent = message; notice.hidden = false;
  if (!notice.isConnected) drawer.querySelector('.drawer__inner')?.append(notice);
  drawer.open();
})();
